import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import { useFetchOrder } from "@/apis/queryFunctions/orderFuntions";
import styled from "@emotion/styled";
import {
  Box,
  Center,
  Container,
  createStyles,
  Text,
  UnstyledButton,
  useMantineTheme,
} from "@mantine/core";
import { useRouter } from "next/router";
import numeral from "numeral";
import PropTypes from "prop-types";
import { useWindowSize } from "../../hooks/useWindowSize";
import Error from "./Error";

const Wrapper = styled.div`
  max-width: 1185px;
  margin: 0 auto;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-items: center;
`;

const Background = styled.div`
  /* background-repeat: no-repeat; */
  background-repeat: repeat-y;
  /* background-size: contain; */
  background-position: center;
  padding: 40px 0 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  margin-bottom: 10px;
`;
const MainText = styled.div`
  line-height: 29px;
  text-align: center;
  font-size: 32px;
`;

const SoTien = styled.div`
  line-height: 49px;
  text-align: center;
  margin-bottom: 10px;
`;

const uesStyle = createStyles((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing.xl * 2,
    borderRadius: theme.radius.md,
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
    border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[3]
      }`,
    [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
      flexDirection: "column-reverse",
      padding: theme.spacing.xl,
    },
  },
  button: {
    marginTop: theme.spacing.xl,
    padding: theme.spacing.md,
    backgroundColor: theme.colors.orange[5],
    color: theme.white,
    borderRadius: theme.radius.xs,
  },
  buttonSecondary: {
    marginTop: theme.spacing.xl,
    padding: theme.spacing.md,
    backgroundColor: theme.colors.gray[5],
    color: theme.white,
    borderRadius: theme.radius.xs,
    marginRight: theme.spacing.md,
  },
}));

function CheckoutAlert({ location, apis }) {
  // useEffect(() => {
  //   const goHome = setTimeout(() => GoHome(), 3000);
  //   return () => {
  //     clearTimeout(goHome);
  //   };
  // }, []);
  const router = useRouter();

  const { classes } = uesStyle();

  const GoHome = () => {
    router.push("/mua-hang/san-pham?sort=newest");
  };

  const PaymentAgain = () => {
    window.location.href = "#/ho-so/quan-ly-don-hang";
  };

  const [info, setinfo] = React.useState({
    isSuccess: null,
    amount: "0",
    message: "",
  });

  const { data: info_order } = useFetchOrder();
  // console.log(111111, info_order)
  const so_ct = info_order?.so_ct;

  useEffect(() => {
    const isSuccess = router.query?.isSuccess;

    const amount = router.query?.amount;
    const message = router.query?.message;
    const orderId = router.query?.orderId;
    const _id = router.query?._id;

    const info = {
      ...info,
      isSuccess: isSuccess === "true",
      amount: Number(amount),
      message: String(message),
      email: String(router.query?.email || ""),
      orderId,
      _id,
    };

    setinfo(info);
  }, [router.query]);

  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  //   let value = params.some_key; // "some_value"
  //   console.log("log amount");

  // if (
  //   !location?.state?.orderSuccess?.isSuccess &&
  //   !getParameterByName("isSuccess")
  // ) {
  //   return (
  //     <Container>
  //       <Wrapper>
  //         <Title>Trang bạn tìm không tồn tại</Title>
  //         <Box
  //           onClick={GoHome}
  //           display="flex"
  //           justifyContent="center"
  //           marginTop={1}
  //         >
  //           <BtnGoHome>Về trang chủ</BtnGoHome>
  //         </Box>
  //       </Wrapper>
  //     </Container>
  //   );
  // }
  console.log("🚀 ~ file: index.page.js:132 ~ useEffect ~ orderId:", info);

  return (
    <Container>
      <Box className={classes.wrapper}>
        <>
          <Wrapper>
            {info.isSuccess === true ? (
              <Background>
                <MainText>Đặt hàng thành công</MainText>
                <Text sx={{ paddingTop: 10 }}>Cảm ơn vì đã đặt hàng!</Text>
                {info?.orderId ||
                  (info?._id && (
                    <Box>
                      <Text
                        sx={{
                          paddingTop: 10,
                          textAlign: "center",
                          flexDirection: "row",
                          display: "flex",
                        }}
                      >
                        Mã đơn hàng là{" "}
                        <Text sx={{ fontWeight: "bold", paddingLeft: 5 }}>
                          {so_ct || info?.so_ct || info?.orderId || info?._id || ""}
                        </Text>
                      </Text>
                    </Box>
                  ))}

                {/* 
                  <Text sx={{ paddingTop: 10, textAlign: "center" }}>
                    Thông báo xác nhận đơn hàng được gửi đến email {info?.email}{" "}
                    của bạn.
                  </Text> */}
                {info?.amount > 0 && !location?.state?.orderSuccess?.isCOD && (
                  <SoTien>{numeral(info?.amount).format("0,0")} đ</SoTien>
                )}
                <UnstyledButton className={classes.button} onClick={GoHome}>
                  Tiếp tục mua hàng
                </UnstyledButton>
              </Background>
            ) : (
              <Background>
                <Error message="Thanh toán không thành công" />
                <Box>
                  <UnstyledButton
                    className={(classes.button, classes.buttonSecondary)}
                    onClick={GoHome}
                  >
                    Về trang chủ
                  </UnstyledButton>
                  <UnstyledButton
                    className={classes.button}
                    onClick={PaymentAgain}
                  >
                    Thanh toán lại
                  </UnstyledButton>
                </Box>
              </Background>
            )}
          </Wrapper>
        </>
      </Box>
    </Container>
  );
}

CheckoutAlert.propTypes = {
  location: PropTypes.object,
  apis: PropTypes.object,
};

export default CheckoutAlert;
